import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import {CSSTransitionGroup} from 'react-transition-group'
import GridList, {GridListTile, GridListTileBar} from 'material-ui/GridList'
import Typography from 'material-ui/Typography'
import AccountCircleIcon from 'material-ui-icons/AccountCircle'
import Avatar from 'material-ui/Avatar'
import AddCircleOutlineIcon from 'material-ui-icons/AddCircleOutline'
import IconButton from 'material-ui/IconButton'
import classNames from 'classnames'

import '../../App.css'
import {objectList as text} from '../text'
import {grey} from 'material-ui/colors/index'

const CELL_HEIGHT = 290

const styles = theme => ({
  gridList: {
    minHeight: 640,
  },
  gridListTile: {
    willChange: 'transform',
    cursor: 'pointer',
  },
  titleBar: {
    background: 'rgba(0,0,0,0)',
    marginRight: 10,
  },
  priceTitleBar: {
    background: 'rgba(0,0,0,0)',
    paddingRight: 10,
  },
  priceTitleBarActionIsShown: {
    transition: 'background 100ms ease-in-out',
    '&:hover': {
      background: 'rgba(255, 145, 104, .25)',
    },
  },
  title: {
    width: 'fit-content',
    color: '#fff',
    background: theme.palette.primary.main,
    borderRadius: 5,
    padding: '0 10px',
    fontSize: '12px',
  },
  noObjectsMessage: {
    marginTop: 15,
    textAlign: 'center',
    color: 'rgba(0,0,0,.54)',
  },
  avatar: {
    backgroundColor: grey[400],
    width: 36,
    height: 36,
  },
})

const ObjectList = ({items = [], showNoObjectsMessage, handleTileClick, showAction = false, handleActionClick = () => {}, width, classes}) => {

  const renderCost = cost => {
    return <span>${cost}/día</span>
  }

  const getCols = width => {
    switch (width) {
      case 'xs':
        return 1
      case 'sm':
        return 2
      case 'md':
        return 3
      case 'lg':
        return 4
      case 'xl':
        return 4
      default:
        return 4
    }
  }

  const renderTransitionGroup = (props) => {
    const {children, ...other} = props
    return (
      <CSSTransitionGroup
        transitionName="object-list"
        transitionEnterTimeout={300}
        transitionLeaveTimeout={300}
        {...other}
      >
        {children}
      </CSSTransitionGroup>
    )
  }

  const getPhoto = (photos) => {
    if (photos.length === 0) return '/assets/imagen_no_disponible.png'
    let photo = photos.find(item => item.MainPhoto === true)
    if (typeof photo === 'undefined') photo = photos[0]
    return photo.Url || '/assets/imagen_no_disponible.png'
  }

  if (showNoObjectsMessage)
    return <Typography variant="body1" className={classes.noObjectsMessage}>{text.noObjectsMessage}</Typography>

  return (
    <GridList
      cellHeight={CELL_HEIGHT}
      cols={getCols(width)}
      spacing={30}
      component={renderTransitionGroup}
      className={classes.gridList}
    >
      {items.map(tile => (
          <GridListTile key={tile.ID} classes={{tile: classes.gridListTile}}>
            <img src={getPhoto(tile.Photo)} alt={tile.Name} onClick={() => handleTileClick(tile.ID)}/>
            <GridListTileBar
              onClick={() => handleTileClick(tile.ID)}
              title=""
              titlePosition="top"
              actionPosition="right"
              actionIcon={
                tile.OwnerData.ProfilePicture && tile.OwnerData.ProfilePicture !== ''
                  ? <Avatar className={classes.avatar} src={tile.OwnerData.ProfilePicture} alt="user"/>
                  : <Avatar className={classes.avatar}><AccountCircleIcon/></Avatar>
              }
              classes={{
                root: classes.titleBar,
                title: classes.title,
              }}
            />
            <GridListTileBar
              title={renderCost(tile.RentPrice)}
              titlePosition="bottom"
              classes={{
                root: classNames(classes.priceTitleBar, {[classes.priceTitleBarActionIsShown]: showAction === true}),
                title: classes.title,
              }}
              actionPosition="right"
              onClick={() => {
                if (showAction === false) {
                  handleTileClick(tile.ID)
                } else {
                  handleActionClick(tile)
                }
              }}
              actionIcon={showAction === false ? null : (
                <IconButton style={{width: 24, height: 24}}>
                  <AddCircleOutlineIcon color={'secondary'}/>
                </IconButton>
              )}
            />
          </GridListTile>
        ),
      )}
    </GridList>
  )
}

ObjectList.propTypes = {
  width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  items: PropTypes.arrayOf(PropTypes.object),
  handleTileClick: PropTypes.func.isRequired,
  showAction: PropTypes.bool,
  handleActionClick: PropTypes.func,
  showNoObjectsMessage: PropTypes.bool.isRequired,
}

export default withStyles(styles, {withTheme: true})(ObjectList)



// WEBPACK FOOTER //
// ./src/common/components/ObjectList.js